<script>
  import { onMount } from 'svelte'
  import { text_entered } from '../stores'
  import { default_preview_width, previews_tracking, previews_font_size } from '../stores'

  let mounted = false
  let element

  onMount(() => {
		mounted = true
		return () => {
			mounted = false
		}
	})

  $: $text_entered && setDefaultWidth()

  function setDefaultWidth() {
    if (mounted) {
      $default_preview_width = element.getBoundingClientRect().width
    }
  }
</script>

<!-- Need to have these outer wrappers to simulate same setup with previews -->
<div class="outer">
  <div class="inner" bind:this={element}
    style="font-size:{Math.pow(1.25, $previews_font_size)}em;">
    
    <span class="test"
      style="letter-spacing:{Math.sign($previews_tracking) * Math.pow(1.25, Math.abs($previews_tracking)) * 0.025}em;">
      {$text_entered}
    </span>
  </div>
</div>

<style>
  .outer {
    position: absolute;
    visibility: hidden;
    top: -1000px;
    font-size: 32px;
  }
  .inner {
    font-size: 1.1rem;  /* Base for font size multiplier */
  }
  .test {
    font-family: 'Raleway Dots', cursive;
  }
</style>